export default {
    methods: {
        isRealtruckBrand(brandName) {
            if (!brandName || !this.$sitewideData.config.madeByRealTruckEnabled) return false

            return !!(
                this.$sitewideData.config.madeByRealTruckBrands?.data.includes(brandName) ||
                this.$sitewideData.config.madeByRealTruckOnlineOnlyBrands?.data.includes(brandName)
            )
        },
    },
}
